var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root skeleton-loader",class:{circle: _vm.circle, fill: _vm.fill},style:({
    '--animation-duration': (_vm.duration + "s"),
    '--animation-delay': (_vm.delay + "s")
  })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }